import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { Navbar } from "./Navbar";
import { Footer } from "./Footer";
import { ThemeToggle } from "./ThemeToggle";

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

interface LayoutProps {
  onLoginClick?: () => void;
  onSignupClick?: () => void;
}

export function Layout({ onLoginClick, onSignupClick }: LayoutProps) {
  return (
    <div className="min-h-screen bg-white text-slate-900 dark:bg-slate-950 dark:text-slate-100 transition-colors duration-200">
      <ScrollToTop />
      <Navbar onLoginClick={onLoginClick} onSignupClick={onSignupClick} />
      <ThemeToggle />
      <Outlet />
      <Footer />
    </div>
  );
}
